import React from 'react'

export default function BlocksDoc() {
    return (
        <div id='blocks'>
            <h3 className="text-lg font-semibold mb-2">🧩 Blocks in Sections</h3>
            <p className="mb-4">
                Blocks allow you to add <strong>repeating elements</strong> inside a section — for example, multiple
                menu items, banners, testimonials, or icons.
            </p>

            <p className="mb-3">A section can have:</p>
            <ul className="list-disc ml-6 mb-4">
                <li>A <code>settings</code> array — defines global settings for the section (like background color, spacing, etc.)</li>
                <li>A <code>blocks</code> array — defines each repeating block within that section</li>
            </ul>

            <h5 className="font-medium mt-4 mb-2">✅ Basic Structure</h5>
            <pre className="bg-gray-100 p-3 rounded-lg text-sm overflow-auto">
                {`{
  "settings": [
    {
      "type": "color_picker",
      "name": "footer_color",
      "label": "Background color",
      "value": "#fafafa"
    },
    {
      "type": "text",
      "name": "footer_title",
      "label": "Footer title",
      "value": "About Us"
    }
  ],
  "blocks": [
    {
      "type": "menu"
    },
    {
      "type": "menu"
    }
  ]
}`}
            </pre>

            <h5 className="font-medium mt-4 mb-2">⚙️ How It Works</h5>
            <ul className="list-disc ml-6 mb-4">
                <li>The <code>settings</code> array defines the main configuration for the entire section.</li>
                <li>The <code>blocks</code> array defines <strong>child components</strong> that can be repeated or managed independently inside the section.</li>
                <li>Each block has a <code>type</code> that links to its block definition.</li>
                <li>Blocks can have their own <code>settings</code>, defined in a separate block schema.</li>
            </ul>

            <h5 className="font-medium mt-4 mb-2">🧱 Block Schema Example</h5>
            <pre className="bg-gray-100 p-3 rounded-lg text-sm overflow-auto">
                {`{
  "type": "menu",
  "name": "Menu block",
  "settings": [
    {
      "type": "text",
      "name": "menu_title",
      "label": "Menu title",
      "value": "Quick Links"
    },
    {
      "type": "nav_menu",
      "name": "menu_items",
      "label": "Menu items",
      "value": ""
    }
  ]
}`}
            </pre>

            <h5 className="font-medium mt-4 mb-2">Adding New Blocks Dynamically</h5>
            <p className="mb-4">
                When editing a section in the builder:
            </p>
            <ul className="list-disc ml-6 mb-4">
                <li>The UI should allow the user to <strong>add a new block</strong>.</li>
                <li>The block type is selected from available block schemas.</li>
                <li>The newly added block’s default settings will be loaded from its schema definition.</li>
            </ul>

            <h5 className="font-medium mt-4 mb-2">💡 Example — Footer Section</h5>
            <pre className="bg-gray-100 p-3 rounded-lg text-sm overflow-auto">
                {`{
  "name": "Footer",
  "settings": [
    {
      "type": "color_picker",
      "name": "footer_color",
      "label": "Background color",
      "value": "#fafafa"
    },
    {
      "type": "nav_menu",
      "name": "footer_nav",
      "label": "Navigation",
      "value": ""
    }
  ],
  "blocks": [
    {
      "type": "menu"
    },
    {
      "type": "menu"
    }
  ]
}`}
            </pre>

            <p className="mt-4 text-gray-600">
                This defines a <strong>footer section</strong> with global color and navigation settings, and two <strong>menu blocks</strong> — which can be repeated, reordered, or removed in the visual editor.
            </p>
        </div>

    )
}
